module.exports = __webpack_public_path__ + "img/vod-02.d392db1d.jpg";